import {
  useEventNotificationsControllerGetAll,
  useEventNotificationsControllerGetById,
} from "service";
import { toast } from "react-toastify";
import { queryClient } from "../../../query-client";
import { queryKeyFn } from "service/api/estabrookContext";
import { NotificationTypeArray } from "service/types/enum/notifications-enum";

export const useEventNotificationsList = (params: {
  page: number;
  limit: number;
  search?: string;
  sort?: "updatedAt" | "orderIndex" | "description";
  order?: "asc" | "desc";
  notificationType?: NotificationTypeArray;
}) => {
  return useEventNotificationsControllerGetAll({
    queryParams: {
      page: params.page,
      limit: params.limit,
      search: params.search,
      sort: params.sort,
      order: params.order,
      notificationType: params.notificationType,
    },
  });
};

export const useUpdateEventNotification = (options?: {
  onSuccess?: () => void;
}) => {
  return useEventNotificationsControllerGetById({
    onSuccess: () => {
      toast.success("Event notification updated successfully");

      queryClient.invalidateQueries({
        queryKey: queryKeyFn({
          path: "/api/v1/admin/event-notifications",
          operationId: "eventNotificationsControllerGetAll",
          variables: {},
        }),
      });

      options?.onSuccess?.();
    },
    onError: () => {
      toast.error("Failed to update event notification");
    },
  });
};
